// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__aM7sL","imageContainer":"Post_imageContainer__r_pKv"};